import type { ReactNode } from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalM,
    paddingBottom: tokens.spacingVerticalM,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    marginBottom: tokens.spacingVerticalL,
  },
  start: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    minWidth: 0,
    flexWrap: 'wrap',
  },
  end: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: tokens.spacingHorizontalS,
    minWidth: 0,
    flexWrap: 'wrap',
  },
});

interface AppToolbarProps {
  start?: ReactNode;
  end?: ReactNode;
}

export function AppToolbar({ start, end }: AppToolbarProps) {
  const styles = useStyles();

  if (!start && !end) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.start}>{start}</div>
      <div className={styles.end}>{end}</div>
    </div>
  );
}
